module.exports = __webpack_public_path__ + "img/01020501.10b31859.png";